import React from 'react';
import './VideoProgressBar.scss'
 import numericFunction from "../../../utils/NumericFunction";

const VideoProgressBar = (props) => {
  //setProgressBarValue
  return (
    <div className={'videoProgressBar'}>
      {/* 4320 ===  every Hour is 180 record So max is  24 * 180 */}
      <progress className={'progress-bar'} value={props.progressBarValue} max={23}/>

      <div className={'d-flex justify-content-between w-100'}>
        {[...Array(24)].map((v, index) => {

          let indexShow = index + ""
          if (index < 10) {
            indexShow = '0' + indexShow
          }
          return <div className={'position-relative'}>
            <div className={'position-absolute'}
                 style={{
                   width: 2,
                   height: 5,
                   backgroundColor:'#DADADA' , //#DADADA
                 }}
            ></div>
           <div className={'numberShows'}> {numericFunction.e2p(indexShow)}</div>
          </div>
        })}
      </div>
    </div>
  );
};

export default VideoProgressBar;
